const hasText = (value: string | null | undefined): value is string =>
  value !== null && value !== undefined && value !== "";

const hasNumber = (value: number | null | undefined): value is number =>
  value !== null && value !== undefined;

const dayFormatter = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  month: "short",
  timeZone: "UTC",
  year: "numeric",
});

const monthFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  timeZone: "UTC",
  year: "numeric",
});

export const formatReportDate = (value: string | null | undefined): string => {
  if (!hasText(value)) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : dayFormatter.format(date);
};

export const formatReportMonth = (value: string | null | undefined): string => {
  if (!hasText(value)) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : monthFormatter.format(date);
};

export const formatReportNumber = (value: number | null | undefined): string =>
  hasNumber(value) ? new Intl.NumberFormat("en-US").format(value) : "—";

export const formatReportDuration = (minutes: number | null | undefined): string => {
  if (!hasNumber(minutes)) return "—";
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours === 0) return `${remainingMinutes} min`;
  return remainingMinutes === 0 ? `${hours} hr` : `${hours} hr ${remainingMinutes} min`;
};
